// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__8Ufo_","header":"PatientBlock_header__2zoWS","label":"PatientBlock_label__rqB6i","option":"PatientBlock_option__3nouk"};